import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { changeDateFormat, getUserInfo } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const OrderCancelInfo = ({ orderCancelInfo, getOrderCancelInfo }) => {
	const [isLoading, setIsLoading] = useState(false);
	const location = useLocation();

	const handleApproveOrReject = (type) => {
		setIsLoading(true);
		const params = new URLSearchParams(location.search);
		const requestId = params.get('requestId');
		let url = `${BASE_URL}/order/cancel/request/${requestId}/`;
		if (type === 'APPROVE') {
			url += 'approve';
		} else {
			url += 'reject';
		}
		ApiClient.POST(url, '', '', true)
			.then((response) => {
				getOrderCancelInfo(requestId);
				toastSuccess(response.data.message);
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
				toastError(error.response.data.message);
			});
	};

	const isManagement = () => {
		return getUserInfo()?.isManagement === true || getUserInfo()?.primaryUserType === 'ADMIN';
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="order-cancel-info d-flex align-items-center">
				<div className="from-info pr-2">
					<p className="regular-14 gray_dark_02 mb-1">From </p>
					<p className="regular-14 gray_dark_01">
						{orderCancelInfo?.requestedBy}{' '}
						<span className="gray_dark_02">
							{changeDateFormat(orderCancelInfo?.requestedAt, 'YYYY-MM-DD', 'DD MMM, YY')}
						</span>
					</p>
				</div>
				<div className="reason pl-3 border-left border-right">
					<p className="regular-14 gray_dark_01 mb-1">Reason for order/style canceling</p>
					<p className="regular-14 gray_dark_02">{orderCancelInfo?.requestorRemarks}</p>
				</div>
				<div className="approve-reject-action d-flex justify-content-end pl-4">
					{orderCancelInfo?.status === 'REQUESTED' && isManagement() && (
						<button
							className="button revise size32 mr-2"
							onClick={() => handleApproveOrReject('REJECT')}
							disabled={isLoading}
						>
							Reject
						</button>
					)}
					{orderCancelInfo?.status === 'REQUESTED' && isManagement() && (
						<button
							onClick={() => handleApproveOrReject('APPROVE')}
							className="button approve size32 ml-1"
							disabled={isLoading}
						>
							Approve
						</button>
					)}
					{orderCancelInfo?.status === 'APPROVED' && (
						<button className="button approved size32">
							<span className="approved-text">Approved</span>
							<span className="bar mx-1 gray_dark_02">|</span>
							<span className="mr-1 gray_dark_02">
								{changeDateFormat(orderCancelInfo?.approvedAt, 'YYYY-MM-DD', 'MMM-DD')}
							</span>
						</button>
					)}
					{orderCancelInfo?.status === 'REJECTED' && (
						<button className="button approved rejected size32">
							<span className="approved-text">Rejected</span>
							<span className="bar mx-1 gray_dark_02">|</span>
							<span className="mr-1 gray_dark_02">
								{changeDateFormat(orderCancelInfo?.approvedAt, 'YYYY-MM-DD', 'MMM-DD')}
							</span>
						</button>
					)}
				</div>
			</div>
		</LoaderComponent>
	);
};

export default OrderCancelInfo;
